const minimumZipcodeLength = (value) => {
  if (!value) {
    return false;
  }
  return value.split('-').join('').length >= 5;
};

export default minimumZipcodeLength;
